import { JmApi } from "../jm-api/jm-api";
import {
  GEOPACKAGE_URL,
  GEOPACKAGE_LAYERS_URL,
  GEOPACKAGE_FEATURES_URL,
} from "../config/urls";

export class GeoPackageService {
  static async uploadGeoPackage(
    file: File,
    projectId: number,
    overwriteExisting = false,
  ) {
    const params = {
      projectId,
      overwrite_existing: overwriteExisting,
    };

    return await JmApi.uploadFile(GEOPACKAGE_URL, file, params);
  }

  static async getGeoPackages(
    projectId: number,
    limit?: number,
    offset?: number,
  ) {
    // console.log(
    //   "getGeoPackages in geopackage-service with projectId: ",
    //   projectId,
    // );
    const url = `${GEOPACKAGE_URL}?projectId=${projectId}`; // TODO: add limit and offset
    // console.log("url in getGeoPackages: ", url);
    return await JmApi.get(url);
  }

  static async getGeoPackageLayers(
    geopackageId: number,
    includeAttributes?: boolean,
    includeSampleFeatures?: boolean,
  ) {
    const url = `${GEOPACKAGE_LAYERS_URL}?geopackageId=${geopackageId}`; // TODO: add includeAttributes and includeSampleFeatures
    return await JmApi.get(url);
  }

  static async getLayerFeatures(
    layerId: number,
    bbox?: string,
    limit?: number,
    offset?: number,
    simplify?: number,
    filterExpr?: string,
  ) {
    let url = `${GEOPACKAGE_FEATURES_URL}?layerId=${layerId}`;

    // Add optional parameters
    if (bbox) url += `&bbox=${bbox}`;
    if (limit) url += `&limit=${limit}`;
    if (offset) url += `&offset=${offset}`;
    if (filterExpr) url += `&filter_expr=${encodeURIComponent(filterExpr)}`;

    try {
      const response = await JmApi.get(url);
      return response;
    } catch (error) {
      console.error(`Error fetching features for layer ${layerId}:`, error);
      throw error;
    }
  }
  /**
   * Update style for a GeoPackage layer
   */
  static async updateLayerStyle(layerId: number, style: any) {
    const url = `${GEOPACKAGE_LAYERS_URL}/${layerId}/style`;

    try {
      const response = await JmApi.put(url, { style });
      return response;
    } catch (error) {
      console.error(`Error updating style for layer ${layerId}:`, error);
      throw error;
    }
  }

  /**
   * Delete a GeoPackage file and all its layers
   */
  static async deleteGeoPackage(geopackageId: number) {
    const url = `${GEOPACKAGE_URL}/${geopackageId}`;

    try {
      const response = await JmApi.delete(url);
      return response;
    } catch (error) {
      console.error(`Error deleting geopackage ${geopackageId}:`, error);
      throw error;
    }
  }
}
